import React from 'react';
import { hardReloadOnce } from '../utils/lazyWithReload';

// Render-crash recovery = a single hard reload (same self-heal as lazyWithReload's
// stale-chunk path, same sessionStorage loop guard). The fallback screen below is
// only ever shown when the error SURVIVES a reload — i.e. a real, persistent crash —
// so a transient failure (HMR skew, one-off race) never strands the user on it.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, terminal: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    if (!hardReloadOnce()) this.setState({ terminal: true });
  }

  render() {
    if (this.state.hasError) {
      // Reload initiated — render nothing while it kicks in.
      if (!this.state.terminal) return null;
      return (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#343433',
          backgroundColor: '#fcfbf8',
          fontFamily: 'Inter, -apple-system, "Segoe UI", Roboto, sans-serif',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.6px', margin: 0 }}>Something went wrong</h1>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '14px 28px',
              backgroundColor: '#ff3e00',
              color: '#fff',
              border: 'none',
              borderRadius: '20px',
              fontFamily: 'inherit',
              fontWeight: 800,
              fontSize: '14px',
              letterSpacing: '.6px',
              textTransform: 'uppercase',
              cursor: 'pointer',
              marginTop: '16px'
            }}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
